import { Bus, Package, UtensilsCrossed, Banknote, HeartPulse, Globe2 } from "lucide-react";

export const navLinks = [
  { href: "#about", label: "About" },
  { href: "#projects", label: "Ecosystem" },
  { href: "#africa", label: "Africa" },
  { href: "#why", label: "Why Us" },
  { href: "#contact", label: "Contact" },
];

export const heroStats = [
  { value: "2020", label: "Founded in the USA" },
  { value: "25+", label: "Active projects" },
  { value: "USA", label: "Operational base" },
  { value: "Africa", label: "Expansion focus" },
];

export const aboutStats = [
  { value: "25+", label: "Business projects" },
  { value: "2", label: "Continents vision" },
  { value: "2020", label: "Creation year" },
  { value: "B2B", label: "Partnership focus" },
];

export const projects = [
  {
    icon: Bus,
    title: "518 Ride",
    desc: "Transportation and shuttle solutions for employees, communities and businesses in New York's Capital Region.",
    span: "lg:col-span-4",
  },
  {
    icon: Package,
    title: "518 Courier",
    desc: "Same-day courier, local logistics, medical courier, retail pickup and business delivery services.",
    span: "lg:col-span-4",
  },
  {
    icon: UtensilsCrossed,
    title: "518 Delivery",
    desc: "Local delivery platform for restaurants, groceries, customers and independent drivers.",
    span: "lg:col-span-4",
  },
  {
    icon: Banknote,
    title: "Obled Money",
    desc: "Cross-border financial access and remittance solutions connecting the diaspora with Africa.",
    span: "lg:col-span-6",
    feature: true,
  },
  {
    icon: HeartPulse,
    title: "Obled Santé",
    desc: "Healthcare access platform helping diaspora families support medical care for relatives in Africa.",
    span: "lg:col-span-3",
  },
  {
    icon: Globe2,
    title: "Africa Representation",
    desc: "Business representation for American companies seeking market entry and commercial growth in Africa.",
    span: "lg:col-span-3",
  },
];

export const africaServices = [
  "Africa market entry support",
  "Business representation",
  "Local partner identification",
  "Distribution and visibility strategy",
  "Cross-border business development",
];

export const africaStats = [
  { value: "USA", label: "→ Africa corridor" },
  { value: "B2B", label: "Partnership model" },
  { value: "∞", label: "Growth opportunities" },
];

export const whyPoints = [
  {
    title: "Partnership First",
    desc: "We focus on long-term collaboration with businesses, institutions, investors and local operators.",
  },
  {
    title: "Operational Execution",
    desc: "Our projects are built around real services, real users and practical market needs.",
  },
  {
    title: "Scalable Vision",
    desc: "We design solutions that can grow from local markets to international opportunities.",
  },
];
